<script>
    import Modal from "./Modal.svelte";
    import SectionButton from "./SectionButton.svelte";
    import { getContext } from "svelte";
    import { api_info, fetchWithAuthentication } from "../api/client.js";

    const context = getContext(api_info);

    let showModal;
    let trainProgress = { message: "...", percent: 0 }; // { message, percent}
    let poller;
    let loading = true;
    async function getTrainingStatus() {
        trainProgress = await fetchWithAuthentication(
            context,
            "/get_training_model_status/",
            {}
        );
        loading = false;
    }
    function showProgress() {
        showModal = true;
        poller = setInterval(getTrainingStatus, 5000);
    }
    function hideProgress() {
        showModal = false;
        if (poller) clearInterval(poller);
    }
</script>

<SectionButton label="สถานะการเทรนข้อมูล" on:click={showProgress} />
<Modal show={showModal} title="สถานะการเทรนข้อมูล" on:close={hideProgress}>
    {#if loading}
        <span class="glyphicon glyphicon-refresh spinning" />
    {:else}
        <p>สถานะ: {trainProgress.message}</p>
        <div class="progress">
            <div
                class="progress-bar"
                role="progressbar"
                aria-valuenow={trainProgress.percent}
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: {trainProgress.percent}%;"
            >
                {trainProgress.percent}%
            </div>
        </div>
    {/if}
</Modal>
